"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = firebaseConnect;

var _differenceWith2 = _interopRequireDefault(require("lodash/differenceWith"));

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _query = require("./actions/query");

var _utils = require("./utils");

var _ReactReduxFirebaseContext = _interopRequireDefault(require("./ReactReduxFirebaseContext"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function firebaseConnect() {
  let queriesConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return WrappedComponent => {
    class FirebaseConnectWrapped extends _react.Component {
      constructor() {
        super(...arguments);

        _defineProperty(this, "firebaseEvents", []);

        _defineProperty(this, "firebase", null);

        _defineProperty(this, "prevData", null);
      }

      componentDidMount() {
        const {
          firebase,
          dispatch
        } = this.props;
        const inputAsFunc = (0, _utils.createCallable)(queriesConfig);
        this.prevData = inputAsFunc(this.props, this.props);
        const {
          ref,
          helpers,
          storage,
          database,
          auth
        } = firebase;
        this.firebase = {
          ref,
          storage,
          database,
          auth,
          ...helpers
        };
        this._firebaseEvents = (0, _utils.getEventsFromInput)(this.prevData);
        (0, _query.watchEvents)(firebase, dispatch, this._firebaseEvents);
      }

      componentWillUnmount() {
        const {
          firebase,
          dispatch
        } = this.props;
        (0, _query.unWatchEvents)(firebase, dispatch, this._firebaseEvents);
      }

      UNSAFE_componentWillReceiveProps(np) {
        const {
          firebase,
          dispatch
        } = this.props;
        const inputAsFunc = (0, _utils.createCallable)(queriesConfig);
        const data = inputAsFunc(np, this.store);

        if (!(0, _isEqual2.default)(data, this.prevData)) {
          const itemsToSubscribe = (0, _differenceWith2.default)(data, this.prevData, _isEqual2.default);
          const itemsToUnsubscribe = (0, _differenceWith2.default)(this.prevData, data, _isEqual2.default);
          this.prevData = data;
          (0, _query.unWatchEvents)(firebase, dispatch, (0, _utils.getEventsFromInput)(itemsToUnsubscribe));
          this._firebaseEvents = (0, _utils.getEventsFromInput)(data);
          (0, _query.watchEvents)(firebase, dispatch, (0, _utils.getEventsFromInput)(itemsToSubscribe));
        }
      }

      render() {
        return _react.default.createElement(WrappedComponent, this.props);
      }

    }

    _defineProperty(FirebaseConnectWrapped, "displayName", (0, _utils.wrapDisplayName)(WrappedComponent, 'FirebaseConnectWrapped'));

    _defineProperty(FirebaseConnectWrapped, "wrappedComponent", WrappedComponent);

    FirebaseConnectWrapped.propTypes = {
      dispatch: _propTypes.default.func.isRequired,
      firebase: _propTypes.default.object.isRequired
    };

    function FirebaseConnectWithContext(props) {
      return _react.default.createElement(_ReactReduxFirebaseContext.default.Consumer, null, _internalFirebase => _react.default.createElement(FirebaseConnectWrapped, _extends({}, props, {
        dispatch: _internalFirebase.dispatch,
        firebase: _internalFirebase
      })));
    }

    FirebaseConnectWithContext.displayName = (0, _utils.wrapDisplayName)(WrappedComponent, 'FirebaseConnect');
    FirebaseConnectWithContext.wrappedComponent = WrappedComponent;
    return (0, _hoistNonReactStatics.default)(FirebaseConnectWithContext, WrappedComponent);
  };
}